
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search, Filter } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

interface CivicEducationFiltersProps {
  contentType: string;
  setContentType: (value: string) => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  onClearFilters: () => void;
}

const CivicEducationFilters: React.FC<CivicEducationFiltersProps> = ({
  contentType,
  setContentType,
  searchTerm,
  setSearchTerm,
  onClearFilters
}) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-4 mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
          <Input
            type="text"
            placeholder="Search content..."
            className="pl-9"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <Button
          variant="outline"
          size="sm"
          onClick={onClearFilters}
          className="w-full sm:w-auto"
        >
          Clear filters
        </Button>
      </div>
      
      <div className={`${isMobile ? 'flex flex-col space-y-4' : 'flex justify-between'}`}>
        <div className="flex items-center gap-2">
          <div className="text-nation-blue dark:text-blue-300 flex items-center">
            <Filter size={18} className="mr-1" />
            <span>Filter:</span>
          </div>

          <Tabs value={contentType} onValueChange={setContentType} className={`w-auto ${isMobile ? 'w-full mb-2' : ''}`}>
            <TabsList className={isMobile ? "w-full flex" : ""}>
              <TabsTrigger value="all" className={isMobile ? "flex-1" : ""}>All</TabsTrigger>
              <TabsTrigger value="podcast" className={isMobile ? "flex-1" : ""}>Podcasts</TabsTrigger>
              <TabsTrigger value="video" className={isMobile ? "flex-1" : ""}>Videos</TabsTrigger>
              <TabsTrigger value="summary" className={isMobile ? "flex-1" : ""}>Summaries</TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default CivicEducationFilters;
